import {
  BaseEditorExtension,
  insertMarkdownExtension,
  starterKitExtension,
} from '@copera/tiptap/extensions';
import { parser } from '@copera/tiptap/markdown';
import { Extensions } from '@tiptap/core';
import {
  draggableNodeExtension,
  dropCursorExtension,
  embedExtension,
  enterBehaveExtension,
  imageUploadExtension,
  openAskAiExtension,
  placeholderExtension,
  selectionHighlightExtension,
} from './extensions';
import { codeblockExtension } from './extensions/codeblock';
import { emojiSearchExtension } from './extensions/emojiSearch';
import { slashCommandExtension } from './extensions/slashCommand';
import { tableExtension } from './extensions/table';

export const minimalExtensions: Extensions = [
  starterKitExtension.configure({
    bold: false,
    blockquote: false,
    bulletList: false,
    gapcursor: false,
    hardBreak: false,
    heading: false,
    italic: false,
    listItem: false,
    orderedList: false,
    strike: false,

    document: true,
    paragraph: true,
    text: true,
  }),
  placeholderExtension,
];

export const basicExtensions: Extensions = [
  BaseEditorExtension.configure({
    historyExtension: false,
    codeblockExtension: false,
    dropCursorExtension: false,
  }),
  selectionHighlightExtension,
  placeholderExtension,
  enterBehaveExtension,
  insertMarkdownExtension.configure({ parser }),
  openAskAiExtension,
];

export const fullExtensions: Extensions = [
  ...basicExtensions,
  dropCursorExtension,
  emojiSearchExtension,
  slashCommandExtension,
  codeblockExtension,
  imageUploadExtension,
  embedExtension,
  draggableNodeExtension,
  tableExtension,
];
